import { serviceLogger } from '../Logger';

const log = serviceLogger.scope('points-info-banner-client');

export class PointsInfoBannerClient {
	constructor() {
	}

	getFromTeaserUI(): Promise<string> {
		const url = `/up-teaserui/pointsInfoBanner`;

		log.info(`[FT9BCN] Calling points info banner endpoint on url: ${JSON.stringify(url)}`);

		return fetch(url, {
			method: 'GET',
			headers: {
				Accept: 'text/html'
			}
		}).then((response) => {
			if (response.status === 200) {
				log.info(`[FT9BCN] points info banner teaser html fetched successfully`);
				return response.text();
			}
			return Promise.reject(
				`Got status code '${response.status}' for points info banner`);
		});
	}
}

